import store from "@/state/store";
import LandingPage from "./views/landingpage/Landingpage";

export default [
  // Welcome Route
  {
    path: "/",
    name: "landing-page",
    component: LandingPage
  },
  // Custom Routes
  {
    path: "/dashboard",
    name: "home",
    component: () => lazyLoadView(import("@/router/views/Dashboard/Dashboard")),
    meta: { authRequired: true }
  },
  {
    path: "/3d-map",
    name: "map3d",
    component: () => lazyLoadView(import("@/router/views/3D/Map3D")),
    meta: { 
      authRequired: true,
      title: "Bản đồ 3D"
    }
  },
  {
    path: "/complaints",
    name: "complaints",
    component: () =>
      lazyLoadView(import("@/router/views/Complaints/Complaints")),
    meta: { authRequired: true }
  },
  {
    path: "/departments",
    name: "departments",
    component: () => lazyLoadView(import("@/router/views/Departments")),
    meta: { authRequired: true }
  },
  {
    path: "/utilities",
    name: "utilities",
    component: () => lazyLoadView(import("@/router/views/Utilities")),
    meta: { authRequired: true }
  },
  {
    path: "/staffs",
    name: "staffs",
    component: () => lazyLoadView(import("@/router/views/Staffs")),
    meta: { authRequired: true }
  },
  {
    path: "/citizens",
    name: "citizens",
    component: () => lazyLoadView(import("@/router/views/Citizens")),
    meta: { authRequired: true }
  },
  {
    path: "/layers",
    name: "layers-management",
    component: () => lazyLoadView(import("@/router/views/LayersManagement")),
    meta: { authRequired: true }
  },
  {
    path: "/roles",
    name: "role-management",
    component: () => lazyLoadView(import("@/router/views/RoleManagement")),
    meta: { authRequired: true }
  },
  {
    path: "/vendors",
    name: "vendors",
    component: () => lazyLoadView(import("@/router/views/Vendors")),
    meta: { authRequired: true }
  },
  {
    path: "/service-requests",
    name: "service-requests",
    component: () => lazyLoadView(import("@/router/views/ServiceRequests")),
    meta: { authRequired: true }
  },
  {
    path: "/dist-admins",
    name: "dist-admins",
    component: () =>
      lazyLoadView(import("@/router/views/DistrictAdminManagement")),
    meta: { authRequired: true }
  },
  {
    path: "/profile",
    name: "profile",
    component: () => lazyLoadView(import("@/router/views/profile/Profile")),
    meta: { authRequired: true }
  },
  {
    path: "/admin/monitor",
    name: "admin-monitor",
    component: () =>
      lazyLoadView(import("@/router/views/SystemMonitoring/SystemMonitoring")),
    meta: { authRequired: true, permissions: ["view:monitor"] }
  },

  // Base Routes
  {
    path: "/login",
    name: "login",
    component: () => lazyLoadView(import("@/router/views/Login")),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (routeTo.query.token) {
          store
            .dispatch("auth/logInByToken", routeTo.query.token)
            .then(() => {
              next({ name: "home" });
            })
            .catch(error => {
              console.error(error);
              next({ name: "404" });
            });

          return;
        }

        // If the user is already logged in
        if (store.state.auth.userToken) {
          // Redirect to the home page instead
          next({ name: "home" });
        } else {
          // Continue to the login page
          next();
        }
      }
    }
  },
  {
    path: "/password/forgot",
    name: "forgot-password",
    component: () =>
      lazyLoadView(import("@/router/views/ForgotPassword/ForgotPassword"))
  },
  {
    path: "/password/reset/:email/:token",
    name: "password-reset",
    component: () =>
      lazyLoadView(import("@/router/views/ForgotPassword/ResetPassword"))
  },
  {
    path: "/404",
    name: "404",
    component: require("@/router/views/_404.vue").default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404"
  }
];

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@/router/views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@/router/views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require("@/router/views/_loading.vue").default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require("@/router/views/_timeout.vue").default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children);
    }
  });
}
